# frozen_string_literal: true

module Engine
  module Game
    module G1807
    end
  end
end
